<template>
<div>
  <nav class="bar bar-nav border" >
      <div style="float:left;width: 86%" v-if="ssoFlag === 0">
        <router-link class="tab-item" :to="{ name: 'finder', params: {ishome: true}}" >
          <div class="search-input" style="margin-top: 0.5rem">
            <label class="icon icon-search1" for="search"></label>
            <input type="search" id='search1' placeholder='输入基因名称...' readonly unselectable="on"/>
          </div>
        </router-link>
    </div>
    <div style="float:left;width: 86%" v-else>
      <div class="search-input" style="margin-top: 0.5rem">
        <label class="icon icon-search" for="search"></label>
        <input type="search" id='search'  class="open-popup open-goods" data-popup=".popup-goods" placeholder='查询基因/产品名称……' readonly unselectable="on" />
      </div>
    </div>
    <span style="float: right;width: 12%">
      <a class="item-link item-content" @click='gotoMymessage()'style="float: right;position: relative;margin-top:4px;">
          <!--<label class="icon icon-message"  style="font-size: 1.6rem;" ></label>-->
         <img src="/static/img/kefu.png" style="width: 2.2rem;height: 2rem">
        <span class="unreadmessage" v-if="curMessageSession.unreadMessagesAmount > 0" >
           {{curMessageSession.unreadMessagesAmount}}</span>
        </a>
          <!--<img src="/static/img/kefu.png" style="width: 2.2rem;height: 2rem">-->
        </span>
  </nav>

  <div class="content"  style="margin-bottom: 2.5rem;background-color: #FFFFFF" >
      <div   class="swiper-container swiper-container-horizontal"  id="sw1"   data-space-between="10"  v-if="promotions" style="margin-left: 0.2rem;margin-right: 0.2rem">
        <div  class="swiper-wrapper" >
          <div class="swiper-slide"  v-for="attr in  promotions" v-if="attr.imageUrl">
            <a :href="getOuterLink(attr)" v-if="openLink(attr)">
              <img  class='card-cover' :src="baseurl + attr.imageUrl" :id="attr.promotionGuid">
            </a>
            <img  class='card-cover' :src="baseurl + attr.imageUrl"  alt=""  @click="todiscount(attr)" v-else>
          </div>
        </div>
        <div class="swiper-pagination">
          <span v-for="index in promotions">
          <span class="swiper-pagination-bullet swiper-pagination-bullet-active " v-if="index === 0"></span>
          <span class="swiper-pagination-bullet" v-for="index in promotions" v-else></span>
            </span>
          <!--<span class="swiper-pagination-bullet swiper-pagination-bullet-active "></span>-->
          <!--<span class="swiper-pagination-bullet" v-for="index in promotions" v-if="index < promotions.length -1 "></span>-->
        </div>
      </div>
      <div  style="color: #8e8e93;margin-bottom: 0.5rem;font-size: 0.8rem;margin-left: 0.5rem;margin-right: 0.5rem;margin-top: 0.5rem" v-if="description">
         <span>{{description}}</span>
         <span  style="float: right">
             <span @click="todiscount(promotionGuid,description)">查看全部</span>
             <span class="icon icon-right"></span>
         </span>
       </div>
      <!--<div  class="swiper-container swiper-container-horizontal" style="height: 8rem;margin-left: 0.5rem;margin-right: 0.5rem"  v-if="merchList.length > 0"     data-space-between="10">-->
          <!--<div  class="swiper-wrapper"    id="merchList"  >-->
              <!--<div class="swiper-slide"  v-for="pro in merchList" >-->
                  <!--<table border="0" cellpadding="0" cellspacing="0" width="100%">-->
                     <!--<tr>-->
                         <!--<td style="width:31%;" >-->
                             <!--<div class="item-link item-content" @click="goToMerchandises(pro[0])">-->
                                <!--<div  v-bind:style="{'background-image': 'url('+ merchandisebaseurl + pro[0].merchandiseIcon +') ', 'background-size': '100% 100%'}"-->
                                      <!--class ="container" style=" height:6.2rem;-->
<!--position:relative; border: 0.05rem solid gray;">-->
                                <!--<div class="inner-triangle" v-if="pro[0].bpromotions[0].type != 0">-->
                                    <!--<div class="inner-text" >{{pro[0].bpromotions[0].typeName}}</div>-->
                                <!--</div>-->
                                  <!--<span class="redmerchdise1"  v-if="pro[0]._titleList && pro[0]._titleList.length > 0">-->
                                    <!--{{pro[0]._titleList[0].valueText}}-->
                                  <!--</span>-->
                                  <!--<span style="position:absolute; left:0; bottom:1.1rem">-->
                                      <!--<div class="redmerchdise2" v-if="pro[0]._abstractList && pro[0]._abstractList.length > 0">{{pro[0]._abstractList[0].valueText}}</div>-->
                                  <!--</span>-->
                                  <!--<span style="position:absolute; left:0; bottom:0">-->
                                      <!--<div class="redmerchdise3"v-if="pro[0]._subTitleList && pro[0]._subTitleList.length>0"> {{pro[0]._subTitleList[0].valueText}}</div>-->
                                  <!--</span>-->
                                  <!--&lt;!&ndash;<span style="position:absolute; left:0; bottom:1.1rem">&ndash;&gt;-->
                                      <!--&lt;!&ndash;<div class="redmerchdise2" v-if="pro[0]._subTitleList && pro[0]._subTitleList.length > 0">{{pro[0]._subTitleList[0].valueText}}</div>&ndash;&gt;-->
                                  <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                  <!--&lt;!&ndash;<span style="position:absolute; left:0; bottom:0">&ndash;&gt;-->
                                      <!--&lt;!&ndash;<div class="redmerchdise3"v-if="pro[0]._abstractList && pro[0]._abstractList.length>0"> {{pro[0]._abstractList[0].valueText}}</div>&ndash;&gt;-->
                                  <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                   <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                <!--</div>-->
                             <!--</div>-->
                             <!--<div>-->
                                <!--<span style="color:#00469A ">¥{{pro[0].priceMax}}-->
                                  <!--<del v-if="pro[0].priceMax" style="color: grey;font-size: 0.3rem">¥{{pro[0].priceMax}}</del>-->
                                <!--</span>-->
                               <!--<a v-on:click="addCartListForRecom(pro[0])" >-->
                                  <!--<span class="icon icon-cart" style="float: right"></span>-->
                               <!--</a>-->
                             <!--</div>-->
                         <!--</td>-->
                         <!--<td style="width:34%;">-->
                             <!--<div class="item-link item-content" @click="goToMerchandises(pro[1])">-->
                                <!--<div class="redmerchdise" v-bind:style="{'background-image': 'url('+ merchandisebaseurl + pro[1].merchandiseIcon +') ', 'background-size': '100% 100%'}">-->
                                <!--<div class="inner-triangle" v-if="pro[1].bpromotions[0].type != 0">-->
                                  <!--<div class="inner-text" >{{pro[1].bpromotions[0].typeName}}</div>-->
                                <!--</div>-->
                                  <!--<span class="redmerchdise1"  v-if="pro[1]._titleList && pro[1]._titleList.length > 0">-->
                                   <!--{{pro[1]._titleList[0].valueText}}-->
                                  <!--</span>-->
                                  <!--<span style="position:absolute; left:0; bottom:1.1rem">-->
                                      <!--<div class="redmerchdise2" v-if="pro[1]._abstractList && pro[1]._abstractList.length > 0">{{pro[1]._abstractList[0].valueText}}</div>-->
                                  <!--</span>-->
                                  <!--<span style="position:absolute; left:0; bottom:0">-->
                                      <!--<div class="redmerchdise3"v-if="pro[1]._subTitleList && pro[1]._subTitleList.length>0"> {{pro[1]._subTitleList[0].valueText}}</div>-->
                                  <!--</span>-->
                                  <!--&lt;!&ndash;<span style="position:absolute; left:0; bottom:1.1rem">&ndash;&gt;-->
                                      <!--&lt;!&ndash;<div class="redmerchdise2" v-if="pro[1]._subTitleList && pro[1]._subTitleList.length > 0">{{pro[1]._subTitleList[0].valueText}}</div>&ndash;&gt;-->
                                  <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                  <!--&lt;!&ndash;<span style="position:absolute; left:0; bottom:0">&ndash;&gt;-->
                                      <!--&lt;!&ndash;<div class="redmerchdise3"v-if="pro[1]._abstractList && pro[1]._abstractList.length>0"> {{pro[1]._abstractList[0].valueText}}</div>&ndash;&gt;-->
                                  <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                   <!--</span>-->
                                 <!--</div>-->
                             <!--</div>-->
                             <!--<div style="margin-left: 0.5rem">-->
                                <!--<span style="color:#00469A ">¥{{pro[1].priceMax}}-->
                                  <!--<del v-if="pro[1].priceMax" style="color: grey;font-size: 0.3rem">¥{{pro[1].priceMax}}</del>-->
                                <!--</span>-->
                                <!--<a v-on:click="addCartListForRecom(pro[1])" >-->
                                  <!--<span class="icon icon-cart" style="float: right"></span>-->
                                <!--</a>-->
                             <!--</div>-->

                         <!--</td>-->
                         <!--<td>-->
                              <!--<div class="item-link item-content"  @click="goToMerchandises(pro[2])">-->
                                 <!--<div class="redmerchdise" v-bind:style="{'background-image': 'url('+ merchandisebaseurl + pro[2].merchandiseIcon +') ', 'background-size': '100% 100%'}" >-->
                                 <!--<div class="inner-triangle" v-if="pro[2].bpromotions[0].type != 0">-->
                                    <!--<div class="inner-text" >{{pro[2].bpromotions[0].typeName}}</div>-->
                                 <!--</div>-->
                                 <!--<span class="redmerchdise1"  v-if="pro[2]._titleList && pro[2]._titleList.length > 0">-->
                                  <!--{{pro[2]._titleList[0].valueText}}-->
                                  <!--</span>-->
                                  <!--<span style="position:absolute; left:0; bottom:1.1rem">-->
                                      <!--<div class="redmerchdise2" v-if="pro[2]._abstractList && pro[2]._abstractList.length > 0">{{pro[2]._abstractList[0].valueText}}</div>-->
                                   <!--</span>-->
                                   <!--<span style="position:absolute; left:0; bottom:0">-->
                                   <!--<div class="redmerchdise3"v-if="pro[2]._subTitleList && pro[2]._subTitleList.length>0"> {{pro[2]._subTitleList[0].valueText}}</div>-->
                                   <!--</span>-->
                                   <!--&lt;!&ndash;<span style="position:absolute; left:0; bottom:1.1rem">&ndash;&gt;-->
                                      <!--&lt;!&ndash;<div class="redmerchdise2" v-if="pro[2]._subTitleList && pro[2]._subTitleList.length > 0">{{pro[2]._subTitleList[0].valueText}}</div>&ndash;&gt;-->
                                   <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                   <!--&lt;!&ndash;<span style="position:absolute; left:0; bottom:0">&ndash;&gt;-->
                                   <!--&lt;!&ndash;<div class="redmerchdise3"v-if="pro[2]._abstractList && pro[2]._abstractList.length>0"> {{pro[2]._abstractList[0].valueText}}</div>&ndash;&gt;-->
                                   <!--&lt;!&ndash;</span>&ndash;&gt;-->
                                 <!--</div>-->
                              <!--</div>-->
                              <!--<div   style="margin-left: 0.5rem">-->
                                <!--<span style="color:#00469A ">¥{{pro[2].priceMax}}-->
                                  <!--<del v-if="pro[2].priceMax" style="color: grey;font-size: 0.3rem">¥{{pro[2].priceMax}}</del>-->
                                <!--</span>-->
                                <!--<a v-on:click="addCartListForRecom(pro[2])" >-->
                                  <!--<span class="icon icon-cart" style="float: right"></span>-->
                                <!--</a>-->
                              <!--</div>-->
                         <!--</td>-->
                     <!--</tr>-->
                  <!--</table>-->
              <!--</div>-->
          <!--</div>-->
      <!--</div>-->


    <div class="swiper-container  "  style=" width: 100%;
      height: 24%;padding-bottom:0px" id="sw" v-if="channels">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <table border="0" cellpadding="0" cellspacing="0" width="100%" height="100%">
<!--            <tr v-if="secPromotion">-->
<!--              <td style="width:20%;">-->
<!--                <div @click="todiscount(secPromotion)" style="margin-right: 0.2rem;margin-left: 0.2rem">-->
<!--                  <img  class='card-cover' :src="baseurl + 'miaosha-banner.JPG'"  alt="秒杀专区" >-->
<!--                </div>-->
<!--              </td>-->
<!--              <td style="width:20%;" v-if="channels"  >-->
<!--                <div @click="gotochannel(channels[0])" style="margin-right: 0.2rem;margin-left: 0.2rem">-->
<!--                  <img  class='card-cover' :src="baseurl + channels[0].imageUrl"  alt="" >-->
<!--                </div>-->
<!--              </td>-->

<!--            </tr>-->
            <tr v-if="channels.length > 1">
              <!--援鄂活动增加左边channel-->
              <!--<td style="width:20%;">-->
                <!--<div @click="gotochannel('doctor')" style="margin-right: 0.2rem;margin-left: 0.2rem">-->
                  <!--<img  class='card-cover' :src="baseurl + 'channel_doctor.jpg'"  alt="" >-->
                <!--</div>-->
              <!--</td>-->
              <!--<td style="width:20%;">-->
                <!--<div @click="gotochannel(channels[1])" style="margin-right: 0.2rem;margin-left: 0.2rem">-->
                  <!--<img  class='card-cover' :src="baseurl + channels[1].imageUrl"  alt="" >-->
                <!--</div>-->
              <!--</td>-->

              <!--未替换前的channel-->
              <td style="width:20%;" v-for="channel in channels"  >
                <div @click="gotochannel(channel)" style="margin-right: 0.2rem;margin-left: 0.2rem">
                  <img  class='card-cover' :src="baseurl + channel.imageUrl"  alt="" >
                </div>
              </td>
            </tr>
            <tr v-else>
              <td style="width:20%;" v-for="channel in channels"  >
                <div @click="gotochannel(channel)" style="margin-right: 0.2rem;margin-left: 0.2rem">
                  <img  class='card-cover' :src="baseurl + channel.imageUrl"  alt="" >
                </div>
              </td>
              <td style="width:20%;">

              </td>
              <!--<td style="width:20%;"  >-->
              <!--<div>-->
              <!--<img  class='card-cover' :src="baseurl + 'g-2.detail'"  alt="" >-->
              <!--</div>-->
              <!--</td>-->
            </tr>
          </table>
        </div>
        <!--<div class="swiper-slide">-->
          <!--<table border="0" cellpadding="0" cellspacing="0" width="100%" height="100%">-->
            <!--<tr>-->
              <!--<td style="width:20%;" v-for="channel in channels" >-->
                <!--<div @click="gotochannel(channel)">-->
                  <!--{{ channel.description}}-->
                <!--</div>-->
              <!--</td>-->
              <!--<td style="width:20%;"  >-->
                <!--<div>-->
                  <!--nihao-->
                <!--</div>-->
              <!--</td>-->
            <!--</tr>-->
          <!--</table>-->
        <!--</div>-->
        <!--<div class="swiper-slide"  ></div>-->
      </div>
      <!-- Add Pagination -->
      <!--<div class="swiper-pagination" >-->
      <!--<span class="swiper-pagination-bullet swiper-pagination-bullet-active " ></span>-->
    <!--</div>-->
    </div>
    <div style="color: #8e8e93;margin-bottom: 0.5rem;font-size: 0.8rem;margin-left: 0.5rem;margin-right: 0.5rem;">
      <span>猜你喜欢</span><span  style="float: right">
            <span @click="topromotion('','猜你喜欢')">查看全部</span>
            <span class="icon icon-right"></span>
         </span>
    </div>
    <div  v-if="recommendsList && recommendsList.length > 0">
    <newMerchandiseListB :merchList="recommendsList" ></newMerchandiseListB>
    </div>
    <div  v-else>
    <newMerchandiseListB :merchList="recommends" ></newMerchandiseListB>
    </div>
    <!--<a id="fakelink" href="https://jinshuju.net/f/nrxuBV" style="visibility: hidden;">下一步</a>-->
  </div>

  <!--<div class="content data-block" style="top: 16.5rem; height: 15rem;" v-if="recommendsList && recommendsList.length > 0">-->
  <!--<merchdata :merchList="recommendsList" ></merchdata>-->
  <!--</div>-->
  <!--<div class="content data-block" style="top: 16.5rem; height: 15rem;" v-else>-->
    <!--<merchdata :merchList="recommends" ></merchdata>-->
  <!--</div>-->
</div>
</template>
<script>
  import $ from 'jquery'
  import emkt from '../emkt.js'
  import {mapMutations, mapState, mapGetters} from 'vuex'
  import merchdata from '../components/MerchandiseList.vue'
  import newMerchandiseListB from './finder/components/NewMerchandiseListB'

  export default {
    mounted () {
      // this.gcapi('getEndPrice', {'quoteId': '701334ba-0f03-4199-b203-ca86d3e6330a', 'discountA': 0.7, 'discountType': 0, 'discountB': 0.700, 'discountC': 1, 'calculatePromotion': false, 'toolUsePromotion': 1, 'serviceUsePromotion': 1, 'settlementAccountNo': 'A00229481', 'startDtLtRgDeadline': false})
      this.fetchData()
      this.init()
      this.getReco()
      this.getSecPromotionInfo()
      console.log('secflag', this.secFlag)
      console.log('promotions', this.promotions)
    },
    created () {
    },
    data () {
      return {
        promotions: emkt.getLocalStorage('EmktPromotions'),
        channels: emkt.getLocalStorage('EmktChannels'),
        // merchList: emkt.getLocalStorage('EmktPlain'),
        baseurl: '/emktResources/resocurces/img/promotion/',
        merchandisebaseurl: '/emktResources/resocurces/img/merchandise/',
        attrurl: '/emktResources/resocurces/img/promotion/',
        hotMerch: [],
        description: '',
        promotionGuid: '',
        recommendsList: [],
        recommends: [],
        ssoFlag: 0,
        secPromotion: emkt.getLocalStorage('EmktSecPromotion')
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'getReco'
    },
    computed: {
      ...mapGetters([
        'hasLogin', 'secFlag', 'curMessageSession'
        // ...
      ]),
      ...mapState([
        'sessionInfo', 'secInfo'
      ])
    },
    components: {
      merchdata, newMerchandiseListB
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'SET_SECPROMOTION_INFO'
      ]),
      getDoctorPromotion () {
        if (!this.promotions) return null
        for (let promotion of this.promotions) {
          if (promotion.promotionGuid.includes('-169')) return promotion
        }
        return null
      },
      addCartListForRecom (pro) {
        this.ADD_CART_LIST(pro)
        $.toast('加入购物车成功！')
      },
      openen () {
        this.$router.push({name: 'finder'})
      },
      gotoMymessage () {
        emkt.openCustomerService()
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
      },
      gotochannel (channel) {
        if (channel === 'doctor') {
          const activityPromotion = this.getDoctorPromotion()
          activityPromotion ? this.todiscount(activityPromotion) : null
          return
        }
        if (channel.type === 6) {
          this.$router.push({path: 'promotion/secpromotion', query: {id: this.secInfo.promotionGuid, des: channel.description, detailImageUrl: channel.detailImageUrl, activityId: channel.activityId}})
        } else if (channel.type === 0) {
          this.$router.push({name: 'Channel', query: {promotionGroupGuid: channel.promotionGroupGuid}})
        } else {
          this.$router.push({name: 'promotions', query: {des: channel.description, promotionGroupGuid: channel.promotionGroupGuid, activityId: channel.activityId}})
        }
      },
      init () {
        $('.swiper-container').swiper({
          autoplay: 3000,
          autoplayDisableOnInteraction: false
        })

//        $('#sw').swiper({
//          direction: 'vertical',
//          autoplay: 3000,
//          autoplayDisableOnInteraction: false
//        })
//        $('.swiper-container').slideTo(0, 3000, false)
      },
      getReco () {
        if (this.$route.name === 'home') {
          let _this = this
          _this.recommendsList = emkt.getLocalStorage('EmktRecommendations')
//          console.log(emkt.getLocalStorage('EmktRecommendations'))
//        if (!self.recommendsList) {
//          this.gcapi('getRecommended').then(function (response) {
//            emkt.setStoreItem('EmktAllRecommends', response.body.result)
//            self.recommendsList = emkt.getLocalStorage('EmktAllRecommends')
//          })
//        }
          if (!_this.recommendsList || _this.recommendsList.length < 4) {
            _this.gcapi('getRecommendation', 'GUEST').then(function (response) {
              var i = 0
              var list = []
              var newlist = response.body.result
//              console.log(newlist)
              if (newlist.length > 15) {
                for (i = 0; i < 15; i++) {
                  list.push(newlist[i])
                }
                emkt.setStoreItem('EmktRecommendations', list)
              } else {
                emkt.setStoreItem('EmktRecommendations', newlist)
              }
//              emkt.setStoreItem('EmktRecommendations', newlist)
              _this.recommendsList = emkt.getLocalStorage('EmktRecommendations')
            })
          }
          if (_this.hasLogin) {
            let customerInfo = _this.sessionInfo.customerInfo
            if (customerInfo && customerInfo.ssoFlag === 0) {
              var ShowPromotions = emkt.getLocalStorage('isshowPromotion')
              if (ShowPromotions && ShowPromotions !== undefined && ShowPromotions !== null && ShowPromotions.show === true) {
                var attr = ShowPromotions.showPromotionParam.bPromotions[0]
                var content = '<div id="lottery"><img style="width: 12rem;height: 20rem;"' + 'src=' + _this.attrurl + attr.showimage + '></div>'
                $.modal({
                  text: content,
                  buttons: [ {
                    text: '我知道了',
                    onClick: function () {
                      emkt.setLocalStorage('isshowPromotion', null)
                      _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam)
                        .then((response) => {
                        })
                    }
                  }]
                })
                $('#lottery').click(function () {
                  emkt.setLocalStorage('isshowPromotion', null)
                  _this.gcapi('acknowledgeShowPromotions', ShowPromotions.showPromotionParam)
                    .then((response) => {
                    })
//                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
//              _this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: ShowPromotions.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl }})
//                  window.open('https://host.convertlab.com/page/6957041337741653896/494a679eb5e44b2c9397aa529f454cf5')
                  if (attr.type === 6 && attr.promotionGuid.indexOf('161') !== -1) {
                    // document.getElementById('fakelink').click()
                    window.location.href = 'https://jinshuju.net/f/nrxuBV'
                  } else if (attr.type === 6) {
                    // 秒杀活动
                    _this.$router.push({path: 'promotion/secpromotion', query: { id: attr.promotionGuid, type: attr.type, des: attr.name, imageUrl: attr.imageUrl, attr: attr, detailImageUrl: attr.detailImageUrl }})
                  } else {
                    _this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, des: attr.name, imageUrl: attr.imageUrl, attr: ShowPromotions, detailImageUrl: attr.detailImageUrl }})
                  }
                  $.closeModal()
                })
              } else {
//                _this.gcapi('getMyCoupons', customerNo).then((res) => {
//                  emkt.setLocalStorage('allCoupons', res.body.result)
//                  _this.myCoupons = res.body.result
//                  if (_this.myCoupons.length > 0) {
//                    var isread = true
//                    for (var i in _this.myCoupons) {
//                      if (_this.myCoupons[i].acknowledge === 0) {
//                        isread = false
//                      }
//                    }
//                    if (!isread) {
//                      $.modal({
//                        text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
//                        buttons: [{
//                          text: '查看全部优惠券',
//                          onClick: function () {
//                            _this.gcapi('acknowledge', customerNo)
//                              .then((response) => {
//                              })
//                            _this.$router.push({name: 'myCoupons'})
//                          }
//                        }, {
//                          text: '我知道了',
//                          onClick: function () {
//                            _this.gcapi('acknowledge', customerNo)
//                              .then((response) => {
//                              })
//                          }
//                        }]
//                      })
//                    }
//                  }
//                })
              }
            }
          }
        }
      },
      fetchData () {
        let _this = this
        if (_this.sessionInfo.ssoFlag !== undefined) {
          _this.ssoFlag = _this.sessionInfo.ssoFlag
        } else {
          _this.ssoFlag = _this.sessionInfo.customerInfo.ssoFlag
        }
        _this.recommends = emkt.getLocalStorage('EmktAllRecommends')
        if (!_this.recommends) {
          this.gcapi('getRecommended').then(function (response) {
            emkt.setStoreItem('EmktAllRecommends', response.body.result)
            _this.recommends = emkt.getLocalStorage('EmktAllRecommends')
          })
        }
        var discounts = []
        discounts = emkt.getLocalStorage('EmktDiscounts')
        if (discounts !== null && discounts !== undefined) {
          _this.description = discounts.description
          _this.promotionGuid = discounts.promotionGuid
        }
        // var data = {'customerNo': '00294934', 'type': 6, 'id': 1, 'name': '高君国自然方案', 'templateNo': 'RSEX0001', 'initPrice': 26460.00, 'children': [{'type': 7, 'id': 1, 'name': '体外建立内皮细胞不完全消融模型', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 1, 'name': '模型建立', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 2, 'name': '线粒体氧化应激', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 2, 'name': 'DCF线粒体氧化应激', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 3, 'name': '线粒体提取', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 3, 'name': '线粒体提取', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 4, 'name': ' 抑制线粒体氧化应激', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 4, 'name': '抗氧化剂NAC', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 5, 'name': '抑制线粒体自噬', 'templateNo': 'EU000150', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 5, 'name': '线粒体自噬抑制剂mdivi', 'templateNo': 'PUEX0001', 'children': []}]}, {'type': 7, 'id': 6, 'name': 'Western blot检测线粒体损伤、自噬和焦亡', 'templateNo': 'EU000126', 'initPrice': 7500.00, 'children': [{'type': 8, 'id': 6, 'name': 'Western blot检测', 'templateNo': 'PU000074', 'number': 5, 'unitPrice': 1500.00, 'initPrice': 7500.00, 'children': []}]}, {'type': 7, 'id': 7, 'name': 'Western blot检测线粒体损伤、自噬和焦亡', 'templateNo': 'EU000126', 'initPrice': 7500.00, 'children': [{'type': 8, 'id': 7, 'name': 'Western blot检测', 'templateNo': 'PU000074', 'number': 5, 'unitPrice': 1500.00, 'initPrice': 7500.00, 'children': []}]}, {'type': 7, 'id': 8, 'name': 'Western blot检测线粒体损伤、自噬和焦亡', 'templateNo': 'EU000126', 'initPrice': 7500.00, 'children': [{'type': 8, 'id': 8, 'name': 'Western blot检测', 'templateNo': 'PU000074', 'number': 5, 'unitPrice': 1500.00, 'initPrice': 7500.00, 'children': []}]}, {'type': 7, 'id': 9, 'name': 'PI/Hoechst双荧光显微镜观察焦亡', 'templateNo': 'EU000149', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 9, 'name': '免疫荧光', 'templateNo': 'PU000097', 'number': 0, 'unitPrice': 250.00, 'initPrice': 0.00, 'children': []}]}, {'type': 7, 'id': 10, 'name': 'PI/Hoechst双荧光显微镜观察焦亡', 'templateNo': 'EU000149', 'initPrice': 0.00, 'children': [{'type': 8, 'id': 10, 'name': '免疫荧光', 'templateNo': 'PU000097', 'number': 0, 'unitPrice': 250.00, 'initPrice': 0.00, 'children': []}]}, {'type': 7, 'id': 11, 'name': 'SYTOX Green流式细胞检测细胞焦亡实验', 'templateNo': 'EU000139', 'initPrice': 1980.00, 'children': [{'type': 8, 'id': 11, 'name': '流式细胞表面分子检测实验（直标抗体）', 'templateNo': 'PU000087', 'number': 6, 'unitPrice': 330.00, 'initPrice': 1980.00, 'children': []}]}, {'type': 7, 'id': 12, 'name': 'SYTOX Green流式细胞检测细胞焦亡实验', 'templateNo': 'EU000139', 'initPrice': 1980.00, 'children': [{'type': 8, 'id': 12, 'name': '流式细胞表面分子检测实验（直标抗体）', 'templateNo': 'PU000087', 'number': 6, 'unitPrice': 330.00, 'initPrice': 1980.00, 'children': []}]}]}
        // var data = {
        //   'type': 6,
        //   'id': 19,
        //   'name': '刘清老师实验方案',
        //   'templateNo': 'RS000018',
        //   'initPrice': 162500.00,
        //   'canMultiDiscount': true,
        //   'children': [
        //     {
        //       'type': 7,
        //       'id': 88,
        //       'name': '肿瘤关键基因筛选及验证',
        //       'templateNo': 'EU000052',
        //       'initPrice': 162500.00,
        //       'canMultiDiscount': true,
        //       'children': [
        //         {
        //           'type': 8,
        //           'id': 186,
        //           'name': '肿瘤关键基因筛选及验证',
        //           'templateNo': 'PU000294',
        //           'unitPrice': 162500.00,
        //           'initPrice': 162500.00,
        //           'canMultiDiscount': true,
        //           'children': []
        //         }
        //       ]
        //     }
        //   ]
        // }
        // var data = {'customerNo': '00382330', 'type': 5, 'id': 7147, 'name': '测试', 'templateNo': 'RSEX0001', 'initPrice': 165200, 'canMultiDiscount': true, 'persist': false, 'children': [{'type': 6, 'id': 24640, 'name': 'TMT蛋白组学', 'templateNo': 'EU000039', 'initPrice': 68000, 'canMultiDiscount': true, 'persist': false, 'children': [{'type': 7, 'id': 54930, 'name': 'TMT蛋白组学6标及以上', 'templateNo': 'PU000264', 'number': 10, 'unitPrice': 4600.00, 'initPrice': 46000, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54931, 'name': '蛋白组学生信分析（A套系）', 'templateNo': 'PU000270', 'number': 1, 'unitPrice': 0.00, 'initPrice': 0, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54932, 'name': '蛋白组学去高丰度蛋白', 'templateNo': 'PU000271', 'number': 10, 'unitPrice': 2200.00, 'initPrice': 22000, 'canMultiDiscount': true, 'persist': false, 'children': []}]}, {'type': 6, 'id': 24641, 'name': '磷酸化TMT蛋白组学', 'templateNo': 'EU000040', 'initPrice': 97200, 'canMultiDiscount': true, 'persist': false, 'children': [{'type': 7, 'id': 54933, 'name': '蛋白组学生信分析（A套系）', 'templateNo': 'PU000270', 'number': 1, 'unitPrice': 0.00, 'initPrice': 0, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54934, 'name': '蛋白组学去高丰度蛋白', 'templateNo': 'PU000271', 'number': 10, 'unitPrice': 2200.00, 'initPrice': 22000, 'canMultiDiscount': true, 'persist': false, 'children': []}, {'type': 7, 'id': 54935, 'name': '磷酸化TMT蛋白组学4标及以上', 'templateNo': 'PU000274', 'number': 10, 'unitPrice': 7520.00, 'initPrice': 75200, 'canMultiDiscount': true, 'persist': false, 'children': []}]}]}
        // this.gcapi('calculateServiceOrderPrice', data).then(function (response) {
        // })
      },
      openLink (attr) {
        const promotionId = attr.promotionGuid
        if (promotionId.endsWith('-251') || promotionId.endsWith('-252') || promotionId.endsWith('-253')) {
          return true
        }
        return false
      },
      getOuterLink (attr) {
        const promotionId = attr.promotionGuid
        if (promotionId.endsWith('-251')) {
          return 'https://jinshuju.net/f/PepHEL'
        } else if (promotionId.endsWith('-252')) {
          return 'https://jinshuju.net/f/BXHWwz'
        } else if (promotionId.endsWith('-253')) {
          return 'https://jinshuju.net/f/QPLea0'
        }
      },
      todiscount (attr) {
        console.log(attr)
        emkt.customerBehaviours.home.clickBanner = {'time': Date.parse(new Date()), 'target': attr.name, 'type': emkt.customerBehaviourType.click}
        if (attr.type === 4) {
          if (attr.action) {
            this.$router.push({path: attr.action})
          } else {
              // eslint-disable-next-line standard/object-curly-even-spacing
            this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, isadvertising: true, detailImageUrl: attr.detailImageUrl, activityId: attr.activityId}})
          }
        } else if (attr.type === 6) {
          // 秒杀活动
          this.$router.push({path: 'promotion/secpromotion', query: { id: attr.promotionGuid, type: attr.type, des: attr.name, imageUrl: attr.imageUrl, attr: attr, detailImageUrl: attr.detailImageUrl, activityId: attr.activityId }})
        } else {
          this.$router.push({path: 'promotion/promotions', query: { id: attr.promotionGuid, type: attr.type, des: attr.name, imageUrl: attr.imageUrl, attr: attr, detailImageUrl: attr.detailImageUrl, activityId: attr.activityId }})
        }
      },
      topromotion (id, des) {
        emkt.customerBehaviours.home.clickLike = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.click}
        this.$router.push({path: 'promotion/promotions', query: { id: id, des: des }})
      },

      goToMerchandises (pro) {
        emkt.customerBehaviours.home.goToDetail = {'time': Date.parse(new Date()), 'target': pro.merchandiseId, 'type': emkt.customerBehaviourType.click}
        this.$router.push({
          name: 'merchandises',
          query: {
            id: pro.merchandiseId,
            typename: pro.bpromotions[0].typeName,
            name: pro.bpromotions[0].name,
            tags: pro.tags
          }
        })
      },
      getSecPromotionInfo () {
        let info = {}
        if (this.secPromotion === '' || this.secPromotion === undefined) {
          return
        }
        info.startDT = this.secPromotion.startDT
        info.endDT = this.secPromotion.endDT
        info.promotionGuid = this.secPromotion.promotionGuid
        info.now = Date.parse(new Date())
        this.gcapi('getSeckillPromotion', info.promotionGuid)
          .then((response) => {
            const result = response.body.result
            Object.assign(info, result)
            this.SET_SECPROMOTION_INFO(info)
            console.log('secinfo', this.secInfo)
            console.log('secflag', this.secFlag)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    border: 0.05rem solid #0b070b;

  }

  .inner-triangle {
    border-right: 1.8rem solid #00469a;
    border-bottom: 2rem solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    right: 0rem;
    z-index: 2;
  }

  .inner-text {
    position: absolute;
    left: 1rem;
    font-size: 0.6rem;
    font-weight: 900;
    transform: rotate(45deg);
  }
  .redmerchdise {
    margin-left: 0.5rem;
    background-size: cover;
    height:6.2rem;
    position:relative;
    border: 0.05rem solid gray;
  }
  .redmerchdise2 {
    font-size:0.6rem;
    border: thin solid black;
    color: white;
    background-color: #00469A;
    margin-left: 0.1rem;
    margin-bottom: 0.1rem;
  }
  .redmerchdise1 {
    position:absolute;
    left:0;
    top:0;
    color:black;
    font-size: 0.7rem;
    margin-left: 0.2rem;
  }
  .redmerchdise3 {
    font-size: 0.6rem;
    color:black;
    font-weight: 900;
    margin-left: 0.2rem;
  }
  .inner-text {
    color: white;
  }
  .swiper-slide {
    text-align: center;
    background: #fff;
    /* Center slide text vertically */

  }
  .unreadmessage {
    position: absolute;
    top:0;
    left:1.7rem;
    color: white;
    background-color: red;
    border-radius: 0.5rem;
    height: 0.8rem;
    width: 0.8rem;
    text-align: center;
    font-size: x-small;
  }




</style>



// WEBPACK FOOTER //
// Home.vue?359eeeb2